export const nonProdEnvironments: Array<string> = [
	'dev',
	'qa',
	'staging',
	'localhost',
];
export const qaEnvironments: Array<string> = ['qa', 'localhost'];
export const devEnvironments: Array<string> = ['dev'];

export enum Environment {
	DEV = 'dev',
	PRODUCTION = 'prod',
	QA = 'qa',
	STAGING = 'staging',
}

export enum AndromedaEnvironment {
	DEV = 'development',
	LOCAL = 'local',
	PRODUCTION = 'production',
	QA = 'qa',
	STAGING = 'staging',
}

export const isProdEnv = (locationHostStringParts: string[]): boolean => {
	return !locationHostStringParts.some((urlPart) =>
		nonProdEnvironments.includes(urlPart)
	);
};

export const isStagingEnv = (locationHostStringParts: string[]): boolean => {
	return locationHostStringParts.some((urlPart) =>
		urlPart.includes('staging')
	);
};

export const isQAEnv = (locationHostStringParts: string[]): boolean => {
	return locationHostStringParts.some((urlPart) =>
		qaEnvironments.some((qaEnvironment) => urlPart.includes(qaEnvironment))
	);
};

export const isDevEnv = (locationHostStringParts: string[]): boolean => {
	return locationHostStringParts.some((urlPart) => urlPart.includes('dev'));
};

export const getEnvironment = (location: Location): string => {
	/*
    const envApi = process.env.VUE_APP_API_ENV;
    if (envApi) {
        return envApi;
    }
    */
	const hostSplit = location.host.includes('localhost')
		? ['localhost']
		: location.host.split('.');
	if (isDevEnv(hostSplit)) {
		return Environment.DEV;
	}
	if (isQAEnv(hostSplit)) {
		return Environment.QA;
	}
	if (isStagingEnv(hostSplit)) {
		return Environment.STAGING;
	}
	return Environment.PRODUCTION;
};
